import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import type { UserModel } from "../models/UserModel"
import type { PressData } from "../models/listpress"

interface ValidationFooterProps {
  isChecked: boolean
  handleCheckboxChange: () => void
  shouldShowBillingOption: () => boolean
  wantsBilling: boolean
  handleBillingToggle: () => void
  amountToPay: number
  isFreeAnnouncement: boolean
  loading: boolean
  handlePayerClick: () => void
  selectedBillingClient: any
  handleBillingButtonClick: () => void
  confirmValidation: () => void
  // Modal states
  showPointsModal: boolean
  setShowPointsModal: (show: boolean) => void
  pointsToUse: number
  setPointsToUse: (value: number) => void
  userDetails: UserModel | null
  discountAmount: number | null
  resetPoints: () => void
  handleUsePoints: () => void
  showAvoirsModal: boolean
  setShowAvoirsModal: (show: boolean) => void
  user: any
  avoirAmountToUse: number
  setAvoirAmountToUse: (value: number) => void
  handleUseAvoirs: () => void
  // Tarif props
  prixHT: number
  prixTTC: number
  remisePourcentage: number
  remisePointsEuros: number
  remiseAvoirsEuros: number
  selectedSupport: PressData | null

  discountPercentageAmount?: number; 
  pointsDiscountAmount?: number; 
  creditNoteDiscountAmount?: number; 
  totalDiscountAmount?: number; 

  discountClaimed?: boolean;
  discountSentToClient?: boolean;
 
}

const ValidationFooter: React.FC<ValidationFooterProps> = ({
  isChecked,
  handleCheckboxChange,
  shouldShowBillingOption,
  wantsBilling,
  handleBillingToggle,
  amountToPay,
  isFreeAnnouncement,
  loading,
  handlePayerClick,
  selectedBillingClient,
  handleBillingButtonClick,
  confirmValidation,
  showPointsModal,
  setShowPointsModal,
  pointsToUse,
  setPointsToUse,
  userDetails,
  discountAmount,
  resetPoints,
  handleUsePoints,
  showAvoirsModal,
  setShowAvoirsModal,
  user,
  avoirAmountToUse,
  setAvoirAmountToUse,
  handleUseAvoirs,
  prixHT,
  prixTTC,
  remisePourcentage,
  remisePointsEuros,
  remiseAvoirsEuros,
  selectedSupport,

  discountPercentageAmount,
  pointsDiscountAmount,
  creditNoteDiscountAmount,
  totalDiscountAmount,

  discountClaimed,
  discountSentToClient
}) => {
  return (
    <div className="validation-footer">
      {/* Checkbox validation */}
      <div className="checkbox-component-container">
        <label className="checkbox-component-label">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="checkbox-component-input"
            disabled={loading}
          />
          <span className="checkbox-component-text">J'ai vérifié et je valide mon annonce</span>
        </label>

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="cgv-tooltip">Voir les Conditions Générales de Vente</Tooltip>}
        >
          <a
            href="https://annonce-legale-officielle.fr/politique-de-confidentialite/"
            target="_blank"
            rel="noopener noreferrer"
            className="checkbox-component-link"
          >
            Je certifie avoir vérifié et validé mon annonce et connaissance des CGV.
          </a>
        </OverlayTrigger>

            {amountToPay > 0 && !isFreeAnnouncement && !wantsBilling && (
              <button
                className={`justificatif-button1 ${!isChecked ? "btn-disabled" : ""}`}
                onClick={handlePayerClick}
                disabled={!isChecked || loading}
              >
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center gap-3 px-5">
                    <span className="vld-texte-span">Chargement</span>
                    <div className="dots-loader mb-2"></div>
                  </div>
                ) : (
                  <span className="vld-texte-span">
                    Payer mon annonce et recevoir mon attestation
                  </span>
                )}
              </button>
            )}


        {shouldShowBillingOption() && !isFreeAnnouncement && (
          <label
            className="billing-checkbox-label"
            style={{ marginTop: 12 }}
          >
            <input
              type="checkbox"
              checked={wantsBilling}
              onChange={handleBillingToggle}
              className="billing-checkbox-input"
              aria-label="Je souhaite demander le paiement de la facture à mon client"
              disabled={!isChecked || loading}
            />
            <span className="billing-checkbox-text">Je souhaite demander le paiement de la facture à mon client</span>
          </label>
        )}
      </div>

      {wantsBilling && selectedBillingClient && (
        <button
          className={`justificatif-button1 ${!isChecked ? "btn-disabled" : ""}`}
          onClick={handleBillingButtonClick}
          disabled={!isChecked || loading}
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center gap-3 px-5">
              <span className="vld-texte-span">Chargement</span>
              <div className="dots-loader mb-2"></div>
            </div>
          ) : (
            <span className="vld-texte-span">
              Envoyer la facturation de mon client
            </span>
          )}
        </button>
      )}

        {(amountToPay === 0 || isFreeAnnouncement) && !wantsBilling && (
          <button
            className={`justificatif-button1 ${!isChecked ? "btn-disabled" : ""}`}
            onClick={confirmValidation}
            disabled={!isChecked || loading}
          >
        {loading ? (
            <div className="d-flex justify-content-center align-items-center gap-3 px-5">
              <span className="vld-texte-span">Chargement</span>
              <div className="dots-loader mb-2"></div>
            </div>
          ) : (
            <span className="vld-texte-span">Valider mon annonce</span>
          )}
        </button>
      )}

      {/* Modal Points */}
      {showPointsModal && (
        <div className="points-modal-overlay">
          <div className="points-modal-container">
            <div className="points-modal-header">
              <h2 className="points-modal-title"> Utiliser mes points</h2>
              <button
                className="points-modal-close-btn"
                onClick={() => setShowPointsModal(false)}
                aria-label="Fermer"
              >
                &times;
              </button>
            </div>
            <div className="points-modal-body">
              <div className="points-balance-card">
                <div className="points-balance-icon">⭐</div>
                <div className="points-balance-info">
                  <p className="points-balance-label">Votre solde disponible</p>
                  <p className="points-balance-amount">
                    {userDetails?.points_balance?.toLocaleString() ?? 0} points
                  </p>
                </div>
              </div>
              <div className="points-input-section">
                <label htmlFor="points-input" className="points-input-label">
                  Combien de points souhaitez-vous utiliser ?
                </label>
                <div className="points-input-wrapper">
             
                  <input
                    id="points-input"
                    type="number"
                    className="points-input"
                    value={pointsToUse}
                    onChange={(e) => {
                      const value = Math.max(
                        0,
                        Math.min(userDetails?.points_balance ?? 0, Number(e.target.value))
                      );
                      setPointsToUse(value);

                      if (value > 0) {
                        handleUsePoints(); 
                      }
                    }}
                    min={0}
                    max={userDetails?.points_balance ?? 0}
                    placeholder="Saisissez le nombre de points"
                  />

                  <span className="points-input-suffix">points</span>
                </div>

                <div className="points-slider-container">
                  <input
                    type="range"
                    className="points-slider"
                    min={0}
                    max={userDetails?.points_balance ?? 0}
                    value={pointsToUse}
                    onChange={(e) => setPointsToUse(Number(e.target.value))}
                  />
                  <div className="points-slider-labels">
                    <span>0</span>
                    <span>{Math.floor((userDetails?.points_balance ?? 0) / 2)}</span>
                    <span>{userDetails?.points_balance ?? 0}</span>
                  </div>
                </div>

                <div className="points-quick-actions">
                  <button
                    type="button"
                    className="points-quick-btn"
                    onClick={() => setPointsToUse(Math.floor((userDetails?.points_balance ?? 0) * 0.25))}
                  >
                    25%
                  </button>
                  <button
                    type="button"
                    className="points-quick-btn"
                    onClick={() => setPointsToUse(Math.floor((userDetails?.points_balance ?? 0) * 0.5))}
                  >
                    50%
                  </button>
                  <button
                    type="button"
                    className="points-quick-btn"
                    onClick={() => setPointsToUse(Math.floor((userDetails?.points_balance ?? 0) * 0.75))}
                  >
                    75%
                  </button>
                  <button
                    type="button"
                    className="points-quick-btn points-quick-btn-max"
                    onClick={() => setPointsToUse(userDetails?.points_balance ?? 0)}
                  >
                    MAX
                  </button>
                </div>
              </div>
              
              <div className="points-summary">
                <div className="points-summary-row">
                  <span>Points à utiliser</span>
                  <span className="points-summary-value">{pointsToUse.toLocaleString()} pts</span>
                </div>
                <div className="points-summary-row">
                  <span>Solde restant après utilisation</span>
                  <span className="points-summary-remaining">
                    {((userDetails?.points_balance ?? 0) - pointsToUse).toLocaleString()} pts
                  </span>
                </div>
                {discountAmount !== null && (
                  <div className="discount-result mt-4">
                    <div className="card  shadow-sm" style={{ borderLeft: '4px solid #4bb0c0' ,boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'}}>
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <div className="bg-opacity-10 p-3 rounded-circle" style={{backgroundColor:"#4bb0c0"}}>
                              <i className="fas fa-tag " style={{ fontSize: '24px',color:'#4bb0c0' }}></i>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="card-title mb-1 justify-content-center text-center"  style={{color:"#4BB0C0"}}>
                              <i className="fas fa-check-circle me-2"></i>
                              Réduction appliquée !
                            </h5>
                            <p className="card-text mb-0">
                              Vous bénéficiez d'une réduction de
                              <span className="fw-bold fs-3 text-dark ms-2">
                                {discountAmount.toFixed(2)} €
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>

            <div className="points-modal-footer">
            <button
              className="points-modal-btn points-modal-btn-cancel"
              onClick={() => {
                resetPoints();          
                setShowPointsModal(false); 
              }}
            >
              Annuler
            </button>

            <button
              className="points-modal-btn points-modal-btn-confirm"
              onClick={() => {
                handleUsePoints();       
                setShowPointsModal(false); 
              }}
              disabled={pointsToUse <= 0 || pointsToUse > (userDetails?.points_balance ?? 0)}
            >
              <span className="btn-icon">✓</span>
              Utiliser {pointsToUse.toLocaleString()} points
            </button>

            </div>
          </div>
        </div>
      )}

      {/* Modal Avoirs */}
      {showAvoirsModal && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <h3>Utiliser mes avoirs</h3>
            <p className="avoirs-info">
              Vous avez <strong> {Number(user.avoir_balance).toFixed(2)} € </strong> d'avoir disponible(s) à utiliser pour cette annonce.
            </p>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                Montant à utiliser (€)
              </label>
              <input
                type="number"
                className="form-control"
                value={avoirAmountToUse}
                onChange={(e) => setAvoirAmountToUse(Number(e.target.value))}
                min={0}
                max={Number(user.avoir_balance)}
                step={0.01}
                style={{ width: '100%' }}
              />
              <small className="text-muted" style={{ display: 'block', marginTop: '4px' }}>
                Maximum disponible: {Number(user.avoir_balance).toFixed(2)} €
              </small>
            </div>

            <div className="modal-actions">
              <button onClick={() => {
                setShowAvoirsModal(false)
                setAvoirAmountToUse(0)
              }}>
                Annuler
              </button>
              <button onClick={handleUseAvoirs}>
                Utiliser {avoirAmountToUse.toFixed(2)} €
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default ValidationFooter
